export enum RadioTypesEnum {
    normal,
    button,
    socialNetworks,
    social
}
